import React, { Fragment } from "react";
import styled from "styled-components";
import Colors from "../../styles/Colors";
import bear from "../../images/bear.png";
import bull from "../../images/bull.png";
import LabelWithHint from "../../components/LabelWithHint";

export const Leverage20 = () => {
  return (
    <Fragment>
      <Image src={bear} />
      <LabelWithHint
        labelComponent={<Unit>Bearish on ETH</Unit>}
        hintText={
          <span>
            Assume that a user deposited $1,000 USDC and opened a position with
            3x leverage, then Diamond Factory will:
            <br />
            <Ol>
              <li>Borrows $2,000 worth of WETH from Diamond Pool</li>
              <li>Sell $500 worth of WETH for USDC on Uniswap</li>
              <li>
                Provide $1,500 USDC + $1,500 worth of WETH to Uniswap WETH/USDC
                pool
              </li>
            </Ol>
          </span>
        }
      />
    </Fragment>
  );
};

export const Leverage15 = () => {
  return (
    <Fragment>
      <Image src={bear} />
      <LabelWithHint
        labelComponent={<Unit>Bearish on ETH</Unit>}
        hintText={
          <span>
            Assume that a user deposited $1,000 USDC and opened a position with
            2.5x leverage, then Diamond Factory will:
            <br />
            <Ol>
              <li>Borrows $1,500 worth of WETH from Diamond Pool </li>
              <li>Sell $250 worth of WETH for USDC on Uniswap </li>
              <li>
                Provide $1,250 USDC + $1,250 worth of WETH to Uniswap WETH/USDC
                pool
              </li>
            </Ol>
          </span>
        }
      />
    </Fragment>
  );
};

export const Leverage10 = () => {
  return (
    <Fragment>
      <Image src={bull} />
      <Unit>/</Unit>
      <Image src={bear} />
      <LabelWithHint
        labelComponent={<Unit>Neutral on ETH</Unit>}
        hintText={
          <span>
            Assume that a user deposited $1,000 USDC and opened a position with
            2x leverage, then Diamond Factory will:
            <br />
            <Ol>
              <li>Borrows $1,000 worth of WETH from Diamond Pool</li>
              <li>
                Provide $1,000 USDC + $1,000 worth of WETH to Uniswap WETH/USDC
                pool
              </li>
            </Ol>
          </span>
        }
      />
    </Fragment>
  );
};

export const Leverage05 = () => {
  return (
    <Fragment>
      <Image src={bull} />
      <LabelWithHint
        labelComponent={<Unit>Bullish on ETH</Unit>}
        hintText={
          <span>
            Assume that a user deposited $1,000 USDC and opened a position with
            1.5x leverage, then Diamond Factory will:
            <br />
            <Ol>
              <li>Borrows $500 worth of WETH from Diamond Pool</li>
              <li>Buys $250 USDC for WETH on Uniswap</li>
              <li>
                Provide $750 USDC + $750 worth of WETH to Uniswap WETH/USDC pool
              </li>
            </Ol>
          </span>
        }
      />
    </Fragment>
  );
};

const Unit = styled.span`
  font-size: 13px;
  line-height: 22px;
  color: ${Colors.ivory};
  margin: 0 8px;
`;

const Image = styled.img`
  width: 16px;
  height: 16px;
`;

const Ol = styled.ol`
  list-style-type: decimal;
  padding-left: 12px;
`;
